<template>
  <article>
    <div class="columns">
      <div class="column">
        <h3 class="title is-5 has-text-centered">Dropped Off Top {{ N }}</h3>
        <FunctionCards :hotpaths="onlyInOld" />
      </div>
      <div class="column">
        <h3 class="title is-5 has-text-centered">Stayed in Top {{ N }}</h3>
        <FunctionCards :hotpaths="inBoth" />
      </div>
      <div class="column">
        <h3 class="title is-5 has-text-centered">New in Top {{ N }}</h3>
        <FunctionCards :hotpaths="onlyInNew" />
      </div>
    </div>
  </article>
</template>

<script>
import FunctionCards from "@/components/FunctionCards.vue";

export default {
  name: "TopNComparison",
  components: {
    FunctionCards
  },
  props: {
    onlyInOld: {
      type: Array,
      default: []
    },
    onlyInNew: {
      type: Array,
      default: []
    },
    inBoth: {
      type: Array,
      default: []
    },
    N: {
      type: Number,
      required: true
    }
  }
}
</script>
